import { parse, setDate, setHours, getTime, setMinutes, setSeconds, setMilliseconds } from 'date-fns/fp';
import flow from 'lodash/fp/flow';
import { AnalysisCalendar } from '@algoan/dashboard/model';

export const setToNoon = flow(setHours(12), setMinutes(0), setSeconds(0), setMilliseconds(0));
export const setToEndOfDay = flow(setHours(23), setMinutes(59), setSeconds(59), setMilliseconds(999));
export const setToStartOfDay = flow(setHours(0), setMinutes(0), setSeconds(0), setMilliseconds(0));
export const setToStartOfDayUTC = (date: Date): Date =>
  new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()));

export const setToFirstDayOfMonth = flow(setDate(1), setToStartOfDay);

export const setToMidOfMonth = setDate(15);
export const parseAnalysisCalendarMonth = parse(new Date())('yyyy-MM');
export const parseDailyBalanceDate = parse(new Date())('yyyy-MM-dd');

export const analysisCalendarMonthToDate = (analysisCalendarMonth: AnalysisCalendar['month']): Date => {
  return flow(parseAnalysisCalendarMonth, setToFirstDayOfMonth, setToNoon)(analysisCalendarMonth);
};

export const convertDatetimeStringToDayTimestamp = (datetime: string): number => {
  return getTime(setToNoon(new Date(datetime)));
};

/**
 * @param dateISOString - string representing a date in ISO_8601 format
 *     ie: '2020-07-12T00:00:00.000Z'
 *     cf: Date.prototype.toISOString()
 * @returns {string} date string, ie '2020-07'
 */
export const extractYearAndMonth = (dateISOString: string): string => dateISOString.slice(0, 7);
